// extracted by mini-css-extract-plugin
export default {"container":"languageFlag_container__umAr1"};